import { AbstractControl,  ValidatorFn } from '@angular/forms';

export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value === null || control.value === undefined) {
      return null; // If there's no value, we consider it valid (you can change this if you want to treat empty as invalid)
    }

    const value = control?.value?.trim();
    const isWhitespace = value.length === 0;
    const isNumber = !isNaN(Number(value));

    const isValid = !isWhitespace && (isNumber || typeof value === 'string');

    if (isValid) {
      return null;
    }

    return { whitespace: true };
  };
}
